import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import {
  addDays,
  addHours,
  addMinutes,
  addMonths,
  addSeconds,
  addWeeks,
  addYears,
  differenceInDays,
  differenceInHours,
  differenceInMilliseconds,
  differenceInMinutes,
  differenceInMonths,
  differenceInSeconds,
  differenceInWeeks,
  differenceInYears,
} from "date-fns";


@Component({
    selector: "app-new-count-down-timer",
    templateUrl: "./new-count-down-timer.component.html",
    styleUrls: ["./new-count-down-timer.component.css"],
    standalone: true,
})
export class NewCountDownTimerComponent implements OnChanges,OnInit {
  public _to: NodeJS.Timeout;
  @Input() waitTitle?: string;
  @Input() isBannerTimerExpired?: boolean;

  @Input()
  public end: number;

  @Input()
  public sec: number;

  @Input()
  public type: string;

  @Output() remainingTime = new EventEmitter<number>();
  @Output() remainingVoucherTime = new EventEmitter<number>();
  public givenDate: Date;
  public displayString = "Loading..";
  imageExists = false;
  public ngOnChanges(): void {
    if (this._to) {
      clearInterval(this._to);
      this._to = undefined;
    }
    const thousand = 1000;
    if (this.type === "seconds") {
      // Only convert to milliseconds if `end` looks like seconds (not already ms).
      // Millisecond epoch timestamps are ~1e12+, so treat smaller values as seconds.
      const msThreshold = 1e12;
      if (this.end && this.end < msThreshold) {
        this.end = this.end * thousand;
      }
    }
    this.givenDate = new Date(this.end);
    this._displayString();
    const intervalTime = this.type === "seconds" ? thousand : thousand * 60;
    this._to = setInterval(() => this._displayString(), intervalTime);
  }

  public _displayString(): void {
    const now: Date = new Date();
    let diff = differenceInMilliseconds(this.givenDate, new Date());
    this.remainingTime.emit(diff);
    this.remainingVoucherTime.emit(diff);
    if (diff >= 0) {
      this.displayString = this.formattedDiffDates(
        new Date(this.givenDate),
        now
      );
    } else {
      // Don't show "Expired", show 00m 00s instead
      this.displayString = "00m 00s";
      clearInterval(this._to);
    }
  }
  private formattedDiffDates(date1, date2): string {
    let years = differenceInYears(date1, date2);
    date2 = addYears(date2, years);

    let months = differenceInMonths(date1, date2);
    date2 = addMonths(date2, months);

    let weeks = differenceInWeeks(date1, date2);
    date2 = addWeeks(date2, weeks);

    let days = differenceInDays(date1, date2);
    date2 = addDays(date2, days);

    let hours = differenceInHours(date1, date2);
    date2 = addHours(date2, hours);

    let minutes = differenceInMinutes(date1, date2);
    date2 = addMinutes(date2, minutes);

    let seconds = differenceInSeconds(date1, date2);
    date2 = addSeconds(date2, seconds);
    if (years != 0) {
      return `${years}y ${months.toString().padStart(2, '0')}m`;
    } else if (months >= 1) {
      return `${months.toString().padStart(2, '0')}m ${weeks}w`;
    } else if (weeks >= 1) {
      return `${weeks}w ${days.toString().padStart(2, '0')}d`;
    } else if (days >= 1) {
      return `${days.toString().padStart(2, '0')}d ${hours.toString().padStart(2, '0')}h`;
    } else if (hours >= 1) {
      return `${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m`;
    } else if (hours == 0 && minutes >= 2) {
      if (this.sec) {
        return `${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
      } else {
        return `${minutes.toString().padStart(2, '0')}m`;
      }
    } else if ((hours == 0 && minutes < 2 && minutes > 0) && this.waitTitle != null) {
      return `Now`;
    } else {
      // Don't show "Expired", show 00m 00s instead
      return "00m 00s";
    }
  }
  ngOnInit() {
    const imgSrc = "https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/game%2FgameSlider%2FRectangle%202416.svg?alt=media&token=82564c3a-0f8d-4bdd-83b4-ac22f7afa9b8";
    const img = new Image();
    img.onload = () => {
      this.imageExists = true;
    };
    img.src = imgSrc;
  }
}
